import { PayloadAction } from '@reduxjs/toolkit';
import { ProductRecommendationSlot, ProductState } from 'store/product/types';
import { AppBundle } from 'api/optimalprint-sdk.d';

export interface SetProductRecommendationPayload {
  products: AppBundle.Api.Entity.Design.V1.ISimilarProduct[];
  productRecommendationStoreSlot: ProductRecommendationSlot;
  slotName: string;
  rootCategoryId?: number;
}

const setProductRecommendationReducer = (
  state: ProductState,
  action: PayloadAction<SetProductRecommendationPayload>,
) => {
  const { products, productRecommendationStoreSlot, slotName, rootCategoryId } = action.payload;

  state.productRecommendations[productRecommendationStoreSlot] = {
    products,
    slotName,
    rootCategoryId,
  };
};

export default setProductRecommendationReducer;
